/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TasksCreateForm/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Assignee from './Assignee/index'
import Board from './Board/index'
import Description from './Description/index'
import DueDate from './DueDate/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import Patient from './Patient/index'
import Priority from './Priority/index'
import React from 'react'
import Stage from './Stage/index'
import Tags from './Tags/index'
import Title from './Title/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TasksCreateForm({
  children,
  viewPath = "/DesignSystem/TasksCreateForm"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtTypographyFontsizeMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.ms'
        })
let dtTypographyLineheightS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.lineHeight.s'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<div
  data-testid="TasksCreateForm.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-tpVT8': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-tpVT8': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-tpVT8': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-tpVT8': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-5-tpVT8': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TasksCreateForm.Horizontal"
  data-view-path={viewPath}
 style={{'--g-5-tpVT8': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Board
  viewPath={`${viewPath}/Board`}
/>
<Stage
  viewPath={`${viewPath}/Stage`}
/>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<div
  data-testid="TasksCreateForm.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-5-tpVT8': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="LINK TO A PATIENT"
 fontSize={dtTypographyFontsizeMs}
 weight="medium"
 lineHeight={dtTypographyLineheightS}
/>
<Patient
  viewPath={`${viewPath}/Patient`}
 width="200px"
/>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<div
  data-testid="TasksCreateForm.Vertical:2"
  data-view-path={viewPath}
 style={{'--g-5-tpVT8': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="TASK DETAILS"
 fontSize={dtTypographyFontsizeMs}
 weight="medium"
 lineHeight={dtTypographyLineheightS}
/>
<div
  data-testid="TasksCreateForm.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-tpVT8': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Assignee
  viewPath={`${viewPath}/Assignee`}
/>
<div
  data-testid="TasksCreateForm.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-5-tpVT8': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<DueDate
  viewPath={`${viewPath}/DueDate`}
/>
<Priority
  viewPath={`${viewPath}/Priority`}
/>
</div>
</div>
<div
  data-testid="TasksCreateForm.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-5-tpVT8': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 alignItems="center"
 weight="medium"
 marginTop={5}
 text="Tags"
 width="100px"
/>
<Tags
  viewPath={`${viewPath}/Tags`}
/>
</div>
<Title
  viewPath={`${viewPath}/Title`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
{children}
</React.Fragment>)
}